/**
 * Hindi labels for the dashboard sidebar navigation tree
 * (see servicesConfigAdvanced.ts). Keyed by node id.
 *
 * Brand names (YouTube, Instagram, Facebook, WhatsApp) stay as-is.
 */
export const SERVICE_LABELS_HI: Record<string, string> = {
  // Automation
  automation: "बिज़नेस ऑटोमेट करें",
  emailAutomation: "ईमेल ऑटोमेशन",
  emailCampaigns: "कैंपेन",
  createCampaign: "कैंपेन बनाएं",
  campaignReports: "रिपोर्ट्स",
  emailTemplates: "टेम्पलेट्स",
  createTemplate: "टेम्पलेट बनाएं",
  templateLibrary: "टेम्पलेट लाइब्रेरी",
  whatsappAutomation: "WhatsApp ऑटोमेशन",
  broadcast: "ब्रॉडकास्ट",
  createBroadcast: "नया ब्रॉडकास्ट",
  broadcastLogs: "लॉग्स",
  autoReply: "ऑटो रिप्लाई",
  createAutoReply: "नियम बनाएं",
  replyAnalytics: "एनालिटिक्स",
  leadAutomation: "लीड ऑटोमेशन",
  leadCapture: "लीड कैप्चर",
  forms: "फॉर्म",
  Leadintegrations: "लीड इंटीग्रेशन",
  followUps: "फॉलो-अप",
  sequence: "सीक्वेंस बिल्डर",
  reminders: "रिमाइंडर्स",

  // Mobile apps
  mobileApps: "मोबाइल ऐप्स",
  allApps: "सभी ऐप्स",
  appAnalytics: "ऐप एनालिटिक्स",

  // Social media growth
  social: "सोशल मीडिया ग्रोथ",
  youtube: "YouTube",
  videoOptimization: "वीडियो ऑप्टिमाइज़ेशन",
  tagExtractor: "टैग एक्सट्रैक्टर",
  seoSuggestions: "SEO सुझाव",
  analytics: "एनालिटिक्स",
  views: "व्यूज़ और वॉच टाइम",
  engagement: "एंगेजमेंट इनसाइट्स",
  commander: "कमांड सेंटर",
  instagramGrowth: "Instagram",
  contentPlanning: "कंटेंट प्लानिंग",
  calendar: "कंटेंट कैलेंडर",
  hashtagResearch: "हैशटैग रिसर्च",
  facebookGrowth: "Facebook",
  homepageFacebook: "होमपेज एनालिटिक्स",

  // Website
  website: "वेबसाइट डेवलपमेंट",
  allWebsites: "सभी वेबसाइट्स",
  pages: "पेज",
  createPage: "पेज बनाएं",
  editPage: "पेज एडिट करें",
  seo: "SEO सेटिंग्स",
  metaTags: "मेटा टैग्स",
  sitemap: "साइटमैप",

  // Tools & utilities
  tools: "टूल्स और यूटिलिटीज़",
  emailTools: "ईमेल",
  emailValidator: "ईमेल वैलिडेटर",
  bulkEmailValidator: "बल्क ईमेल वैलिडेटर",
  smsTools: "SMS",
  smsSender: "SMS भेजें",

  // Integrations
  integrations: "इंटीग्रेशन",
  facebookConnect: "Facebook",
  instagramConnect: "Instagram",
  youtubeConnect: "YouTube",
  whatsappConnect: "WhatsApp Business",
  googleBusiness: "Google बिज़नेस प्रोफ़ाइल",
};
